<template>
  <div class="custom-block-wrapper">

    <div class="cb-container parent">
      <div class="cb-info">
        <div class="head-title">What's New</div>
        <div class="cb-info__title">{{ currentSlide?.title }}</div>
        <div class="cb-info__desc" v-for="line in currentSlide?.content" :key="line">{{ line }}</div>
        <div class="cb-info__link" v-if="currentSlide?.link">
          <router-link :to="linkTarget">{{ currentSlide?.link.label }}</router-link>
        </div>
      </div>
      <div class="swipe-container">
        <div class="swiper-button-prev">
          <i class="material-icons-outlined">chevron_left</i>
        </div>
        <div class="banner-slider-wrapper custom-block">
          <swiper 
            :modules="modules" 
            :slides-per-view="1" 
            :loop="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }"
            @slideChange="onSlideChange"
            class="banner-slider">
            <swiper-slide v-for="(slide, index) in slides" :key="index">
              <div class="cb-container">
                <div class="cb-image">
                  <img :src="slide.image" alt="GrabMart"/>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-button-next">
          <i class="material-icons-outlined">chevron_right</i>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import banner from "@/assets/bannerslider/banner-3-768w.webp";
import banner2 from "@/assets/bannerslider/custom-block-2.png";
SwiperCore.use([Navigation, Autoplay]);

export default {
  name: "CustomBlock",
  components: { Swiper, SwiperSlide },
  data(){
    return {
      loading: false,
      modules: [Navigation, Autoplay],
      title: "INTRODUCING NEW PURSUITS",
      description: [
        `Peak Pursuits strengthens its growing category of adventure itineraries and activities with a reinvigorated partnership with R.O.X. along with the brand’s “New Era of Adventure”.`,
        `Discover new ways to move and explore with an expanded roster of experiences that shows you more reasons to love adventure. Join a community that shares the same passion of constantly living in pursuit of the next adventure.`
      ],
      slides: [
        { 
          image: banner,
          title: "Introducing new pursuits",
          content: [
            "Discover new ways to move and explore with an expanded roster of experiences designed for every stage of a life in motion, and join a community that shares the same passion of constantly living in pursuit of the next adventure.",
            "Train. Adventure. Recover. Repeat"
          ],
          link: {
            label: "Start your pursuits here",
          }
        },
        { 
          image: banner2,
          title: "A new playground to pursue your peak",
          content: [
            "Peak Pursuits is bringing outdoor energy to the heart of the urban jungle at the brand new R.O.X. flagship store in Bonifacio High Street.",
            "Take on the challenge of Power Up’s bouldering wall, train with Ascend Performance Center’s dedicated Hyrox classes and RevformX’s Pilates sessions, and explore the multi-level space making way for a new era of adventure."
          ],
        },
      ],
      currentSlideIndex: 0
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    currentSlide(){
      return this.slides[this.currentSlideIndex];
    },
    linkTarget(){
      if(this.isLoggedIn) return '/events';
      return '/login'
    }
  },
  methods: {
    onSlideChange(swiper) {
      this.currentSlideIndex = swiper.realIndex;
    },
    clickSlide(slide) {
      let page = '/login';
      if(!slide.requireLogin) {
        page = '/events';
      } else if (this.isLoggedIn) {
        page = '/events';
      }
      this.$router.push(page);
    }
  }
}
</script>
<style scoped lang="scss">
.swipe-container {
  width: 100%;
  position: relative;
  height: fit-content;
  display: flex;
  align-items: center;
  .swiper-button-prev,
  .swiper-button-next {
    position: static; // disable Swiper's default positioning
    margin-top: 0;
    min-width: 40px;
    min-height: 40px;
    max-width: 40px;
    max-height: 40px;
    border-radius: 50%;
    background: $green-dark;
    color: $white;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &::after {
      display: none; // hide default arrow icon
    }
    i {
      font-size: 32px;
      color: $white;
    }
  }
  .swiper-button-next {
    right: 0;
  }
}
.custom-block-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  position: relative;
}
.head-title {
	text-align: left;
	font-family: 'Berthold Akzidenz Grotesk Medium';
	font-size: 2em;
	color: $blue-head;
  margin-bottom: 32px;
  line-height: normal;
}
.cb-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  position: relative;
  &:is(.parent) {
    padding-inline: 20px;
  }
  .swipe-container {
    flex: 1;
  }
}
.cb-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: left;
  &__title {
    font-size: 22px;
    font-family: "Berthold Akzidenz Grotesk Medium";
    margin-bottom: 20px;
    line-height: normal;
  }
  &__desc {
    color: $secondary-color-60;
    display: block;
    margin-bottom: 16px;
    font-size: 16px;
  }
  &__link {
    color: $green-dark;
    font-family: "Berthold Akzidenz Grotesk Medium";
    cursor: pointer;
    text-decoration: underline;
    width: fit-content;
  }
  &__button {
    padding-inline: 32px;
    padding-block: 8px;
    border-radius: 24px;
    background: $main-red;
    color: $white;
    font-family: "Berthold Akzidenz Grotesk Medium";
    border: none;
    cursor: pointer;
    width: fit-content;
    box-shadow: -1px 1px 8px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -1px 1px 8px rgba(0, 0, 0, 0.3);
    &:hover {
      background: $primary-color-60;
    }
  }
}
.cb-image {
  flex: 1;
  aspect-ratio: 3/2;
  overflow: hidden;
  border-radius: 16px;
  img {
    width: 100%;
    aspect-ratio: inherit;
    border-radius: 16px;
    object-fit: cover;
  }
}
@media (min-width: 672px) {
  .cb-container {
    flex-direction: row !important;
    justify-content: space-between;
    aspect-ratio: 5/1.5;
  }
  .cb-info {
    padding-top: 12px;
  }
}
@media (min-width: 672px) and (max-width: 1024px) {
  .cb-container {
    flex-direction: column !important;
    aspect-ratio: unset !important;
  }
}
</style>